import React from 'react';
import {Tabs} from 'antd';

import {helpConfigs, helpZhaPianConfigs} from '../../configs';

import './index.scss';

function TabsChildren({configs}) {
    return (
        <div className="children-container flex gap-[12px] flex-wrap">
            {configs.map(item => (
                <div className="children-container-box">
                    {item.title}
                    {item.des}
                </div>
            ))}
        </div>
    );
}

const items = [
    {
        key: '1',
        label: '常见问题',
        children: <TabsChildren configs={helpConfigs} />,
    },
    {
        key: '2',
        label: '网络诈骗专题',
        children: <TabsChildren configs={helpZhaPianConfigs} />,
    },
];

export default function Help() {
    return (
        <div id="help-pc" className="px-[8.3vw] mb-[24px]">
            <Tabs defaultActiveKey="1" items={items} />
        </div>
    );
}
